import script from "./AdminOffer.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOffer.vue?vue&type=script&setup=true&lang=js"

import "./AdminOffer.vue?vue&type=style&index=0&id=deaf4936&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-deaf4936"]])

export default __exports__